/**
 * Sunday: clips inside article bodies (figure.sd-xfig video). 22 Oct 2026.
 * The article's HTML carries the clip with preload="none" and no autoplay; here it plays, muted and looping,
 * only while at least 40% of it is on screen, and one at a time. Reduced motion or data saver: the poster stays.
 * No words here.
 */
const vids = [...document.querySelectorAll('.sd-xfig video')];
if (vids.length) {
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData);
  for (const v of vids) {
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.removeAttribute('autoplay');
  }
  if (!calm && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.4) {
          for (const o of vids) if (o !== v && !o.paused) o.pause();
          v.play().catch(() => {});
        } else if (!v.paused) {
          v.pause();
        }
      }
    }, { threshold: [0, 0.4] });
    vids.forEach((v) => io.observe(v));
  }
}
